import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../store/authSlice";
import { useNavigate, Link } from "react-router-dom";
import ParticlesBg from "particles-bg";
import NavMenu from "./Menu";
import {
  Container,
  Box,
  Typography,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, isAuthenticated } = useSelector(
    (state) => state.auth
  );

  const [formData, setFormData] = useState({ email: "", password: "" });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await dispatch(loginUser(formData));
  };

  useEffect(() => {
    if (isAuthenticated) navigate("/dashboard", { replace: true });
  }, [isAuthenticated, navigate]);

  return (
    <div
      style={{
        position: "relative",
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "radial-gradient(circle at center, #000814 0%, #001F3F 100%)",
      }}
    >
      <ParticlesBg type="circle" color="#4FC3F7" num={60} bg={true} />
      <NavMenu />

      <Container
        maxWidth="xs"
        sx={{
          zIndex: 2,
          background: "rgba(255,255,255,0.1)",
          backdropFilter: "blur(14px)",
          padding: "40px 30px",
          borderRadius: "20px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
          textAlign: "center",
          color: "#fff",
        }}
      >
        <Typography variant="h4" sx={{ mb: 1, fontWeight: "bold" }}>
          Welcome Back
        </Typography>
        <Typography sx={{ color: "rgba(255,255,255,0.7)", mb: 3 }}>
          Log in to your Knight’s Kennel Dashboard
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="normal"
            label="Email"
            variant="outlined"
            name="email"
            value={formData.email}
            onChange={handleChange}
            InputProps={{
              style: { color: "#fff", borderColor: "rgba(255,255,255,0.3)" },
            }}
            InputLabelProps={{ style: { color: "#ccc" } }}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Password"
            type="password"
            variant="outlined"
            name="password"
            value={formData.password}
            onChange={handleChange}
            InputProps={{
              style: { color: "#fff", borderColor: "rgba(255,255,255,0.3)" },
            }}
            InputLabelProps={{ style: { color: "#ccc" } }}
          />

          <Button
            fullWidth
            variant="contained"
            type="submit"
            disabled={loading}
            sx={{
              mt: 3,
              py: 1.5,
              fontWeight: "bold",
              background: "linear-gradient(135deg, #1565C0, #42A5F5)",
              "&:hover": {
                background: "linear-gradient(135deg, #42A5F5, #1565C0)",
              },
            }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
          </Button>
        </form>

        {error && (
          <Typography sx={{ mt: 2, color: "#FF8A80" }}>{error}</Typography>
        )}

        <Typography sx={{ mt: 3 }}>
          Don’t have an account?{" "}
          <Link
            to="/register"
            style={{ color: "#4FC3F7", textDecoration: "none", fontWeight: "bold" }}
          >
            Register
          </Link>
        </Typography>
      </Container>
    </div>
  );
};

export default Login;
